<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/userView" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("system.label.createUser") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider rules="required" v-slot="{ errors }" name="user name">
                <vs-input
                  :label="$t('system.label.userName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="userInfo.username"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="first name"
              >
                <vs-input
                  :label="$t('system.label.firstName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="userInfo.firstname"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha"
                v-slot="{ errors }"
                name="last name"
              >
                <vs-input
                  :label="$t('system.label.lastName')"
                  class="w-full mt-5 mb-2 font-semibold starlabel"
                  style="margin-bottom: 20px"
                  v-model="userInfo.lastname"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider rules="required|email" v-slot="{ errors }" name="email">
                <vs-input
                  :label="$t('system.label.email')"
                  class="w-full mb-2 mt-5 font-semibold starlabel"
                  v-model="userInfo.email"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full">
              <vs-checkbox
                class="mt-5 mb-5 font-semibold"
                :value="isSelector"
                v-model="userInfo.sendPasswordToEmail"
                @change="checkPasswordReset()"
                >{{ $t("system.label.autoGeneratePassword") }}</vs-checkbox
              >
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="relative w-full" v-if="!userInfo.sendPasswordToEmail">
                <ValidationProvider rules="required" v-slot="{ errors }" name="password">
                  <div class="password-container">
                    <vs-input
                      :label="$t('system.label.password')"
                      class="w-full mb-3 font-semibold starlabel"
                      :type="passwordFieldType"
                      v-model="userInfo.password"
                      @input="checkPasswordStrength"
                    />
                    <button
                      v-if="userInfo.password"
                      type="button"
                      class="absolute right-0 pr-3 flex items-center eye-btn"
                      @click="togglePasswordVisibility"
                    >
                      <span v-if="isPasswordVisible">
                        <i
                          style="top: -3px; right: 16px"
                          class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                          >icon iconvisibility_off</i
                        ></span
                      >
                      <span v-else>
                        <i
                          style="top: -3px; right: 16px"
                          class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                          >icon iconvisibility</i
                        >
                      </span>
                    </button>
                  </div>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
                <small v-if="userInfo.password && passwordStrength">
                  Password Strength:
                  <small :class="passwordStrengthClass">
                    {{ passwordStrength }}
                  </small>
                </small>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div v-if="!userInfo.sendPasswordToEmail" class="relative w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="repeat password"
                >
                  <div class="password-container">
                    <vs-input
                      :label="$t('system.label.repeatPassword')"
                      class="w-full mb-3 font-semibold starlabel"
                      :type="repeatPasswordFieldType"
                      v-model="userInfo.repeatPassword"
                    />
                    <button
                      v-if="userInfo.repeatPassword"
                      type="button"
                      class="absolute right-0 pr-3 flex items-center eye-btn"
                      @click="toggleRepeatPasswordVisibility"
                    >
                      <span v-if="isRepeatPasswordVisible"
                        ><i
                          style="top: -3px; right: 16px"
                          class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                          >icon iconvisibility_off</i
                        ></span
                      >
                      <span v-else>
                        <i
                          style="top: -3px; right: 16px"
                          class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon material-icons null icon-after cursor-pointer"
                          >icon iconvisibility</i
                        ></span
                      >
                    </button>
                  </div>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
                <small v-if="passwordMismatch" class="text-red-500">
                  {{ $t("Password not matched") }}
                </small>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.availableRoles")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="available roles"
                >
                  <v-select
                    label="name"
                    multiple
                    v-model="roleName"
                    :options="selected"
                    @input="changeName(roleName)"
                    @option:selecting="selectingRole"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2 select-style"
                  >
                    <template v-slot:option="option">
                      {{
                        option.clientname
                          ? option.name + " ---- " + option.clientname
                          : option.name
                      }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("system.label.entity") }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="business entity"
                >
                  <v-select
                    label="item"
                    v-model="selectedOffice"
                    :options="officeList"
                    @input="selectedOffices(selectedOffice)"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2 select-style"
                  >
                    <template v-slot:option="option">{{ option.item }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("system.label.reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            :disabled="passwordMismatch"
            @click="validateForm"
            >{{ $t("system.label.submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const createUserObj = {
  sendPasswordToEmail: false,
  roles: [],
  keycloakRoleMappings: [],
  username: "",
  password: "",
  firstname: "",
  lastname: "",
  email: "",
  repeatPassword: "",
  officeId: 0,
};

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("RBAC"), to: "" },
        { name: this.$t("system.label.users"), to: "/userView" },
        { name: this.$t("system.label.createUser"), to: "/" },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      userInfo: createUserObj,
      selected: [],
      roleName: "",
      officeList: [],
      selectedOffice: "",
      isSelector: "",
      entityData: [],
      data: {},
      isPasswordVisible: false,
      isRepeatPasswordVisible: false,
      passwordStrengthClass: "",
      passwordStrength: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    passwordFieldType() {
      return this.isPasswordVisible ? "text" : "password";
    },
    repeatPasswordFieldType() {
      return this.isRepeatPasswordVisible ? "text" : "password";
    },

    passwordMismatch() {
      if (!this.userInfo.sendPasswordToEmail) {
        return (
          this.userInfo.password &&
          this.userInfo.repeatPassword &&
          this.userInfo.password !== this.userInfo.repeatPassword
        );
      } else return false;
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch("users/createUserAction", this.userInfo);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "User Created Successfully!",
          type: "success",
        });
        this.$router.push("/userView");
      } catch (e) {
        const errorMessage = String(e).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    selectingRole(role) {
      if (this.roleName.includes(role)) {
        this.$toasted.info(role.name + " already selected", {
          position: "top-right",
          duration: 2000,
        });
      }
    },
    changeName(selectedRoles) {
      this.userInfo.roles = [];
      this.userInfo.keycloakRoleMappings = [];
      selectedRoles.forEach((r) => {
        const role = this.data.availableRoles.find((e) => e.name === r.name);
        if (role) {
          this.userInfo.roles.push(role.id.toString());

          if (role.keycloakRoles && role.keycloakClients) {
            this.userInfo.keycloakRoleMappings.push({
              keycloakRole: role.keycloakRoles,
              keycloakClient: role.keycloakClients,
            });
          }
        }
      });
    },
    selectedOffices(off) {
      this.data.allowedOffices.map((e) => {
        if (e.name == off) {
          this.userInfo.officeId = e.id;
        }
      });
    },
    async getAvailableData() {
      try {
        const response = await this.$store.dispatch("users/getUserTemplateData");
        this.data = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    checkPasswordReset() {
      this.userInfo.repeatPassword = "";
      this.userInfo.password = "";
    },
    resetForm() {
      this.userInfo = createUserObj;
      (this.userInfo.sendPasswordToEmail = false),
        (this.selected = []),
        (this.userInfo.username = ""),
        (this.roleName = ""),
        (this.userInfo.password = ""),
        (this.userInfo.firstname = ""),
        (this.userInfo.lastname = ""),
        (this.userInfo.email = ""),
        (this.userInfo.repeatPassword = ""),
        (this.userInfo.officeId = 0),
        (this.selectedOffice = "");
      if (this.data.availableRoles) {
        this.data.availableRoles.forEach((role) => {
          this.selected.push({ name: role.name, clientname: role.clientname });
        });
      }
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    toggleRepeatPasswordVisibility() {
      this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
    },
    checkPasswordStrength() {
      const password = this.userInfo.password;
      const hasNumber = /[0-9]/;
      const hasUppercase = /[A-Z]/;
      const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      const minLength = 8;
      if (/\s/.test(password)) {
        this.passwordError = "Password cannot contain spaces.";
        this.passwordStrength = "Weak";
        this.passwordStrengthMessage = "";
        this.passwordStrengthClass = "text-red-500";
        return;
      } else {
        this.passwordError = "Password cannot contain spaces.";
      }
      const isStrong =
        password.length >= minLength &&
        hasNumber.test(password) &&
        hasUppercase.test(password) &&
        hasSpecial.test(password);
      if (isStrong) {
        this.passwordStrength = "Strong";
        this.passwordStrengthClass = "text-green-500";
        return;
      }
      const isMedium =
        password.length >= minLength &&
        hasNumber.test(password) &&
        hasUppercase.test(password);

      if (isMedium) {
        this.passwordStrengthClass = "text-yellow-500";
        this.passwordStrength = "Medium";
        return;
      }
      const isWeak = password.length <= minLength;
      if (isWeak) {
        this.passwordStrengthClass = "text-red-500";
        this.passwordStrength = "Weak";
        return;
      }
      return "Password must be at least 8 characters long, contain atleat one special character, one capital letter, and one number.";
    },
  },
  watch: {
    data(val) {
      for (let role of val.availableRoles) {
        this.selected.push({ name: role.name, clientname: role.clientname });
      }
      if (val.allowedOffices) {
        for (let role of val.allowedOffices) {
          this.officeList.push(role.name);
          if (role.name === "Service Provider") {
            this.selectedOffice = role.name;
            this.userInfo.officeId = role.id;
          }
        }
      }
    },
  },
  created() {
    this.getAvailableData();
  },
  mounted() {
    this.resetForm();
  },
};
</script>
<style>
.eye-btn {
  background: none;
  border: none;
  font-size: 20px;
}
.password-container {
  display: flex;
  align-items: center;
}
.text-red-500 {
  color: red;
}

.text-yellow-500 {
  color: yellow;
}

.text-green-500 {
  color: green;
}
.select-style .vs__selected-options {
  padding: 7px 2px 2px 2px !important;
}
</style>
